// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import Button from '../../../components/Button';
import CloseIcon from '../assets/close.svg'
import PasswordInput from '../../../components/PasswordInput';

const S = {
  Container: styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.71);
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  Card: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 494px;
    background-color: #FFFFFF;
    position: relative;
    padding: 44px 29px 29px;
  `,
  CloseButton: styled.img.attrs({ src: CloseIcon })`
    position: absolute;
    height: 20px;
    width: 20px;
    top: 16px;
    right: 16px;
    cursor: pointer;
  `,
  Form: styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 35px;
  `,
  FormTitleWrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    margin: 0 0 32px 0;
  `,
  PasswordInput: styled(PasswordInput)`
    margin-bottom: 15px;
  `,
  FormTitle: styled.div`
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    color: #434343;
  `,
  FormSubtitle: styled.div`
    font-size: 18px;
    line-height: 26px;
    color: #666666;
    margin-top: 12px;
  `,
  NotePasswordRule: styled.div`
    font-size: 14px;
    line-height: 20px;
    color: #666666;
  `,
  SubmitButton: styled(Button)`
    margin-top: 40px;
    align-self: flex-end;
    font-size: 18px;
    line-height: 26px;
    color: #FFFFFF;
    background: #EF8200;
    border-radius: 4px;
    height: 44px;
    width: 112px;
    bottom: 20px;
    right: 20px;
  `,
  ResultImg: styled.img`
    width: 220px;
    height: 220px;
  `,
  ResultTitle: styled.div`
    margin-top: 9px;
    font-weight: 500;
    font-size: 24px;
    line-height: 35px;
    text-align: center;
    color: #434343;
  `,
  ResultDescription: styled.div`
    margin-top: 9px;
    font-size: 16px;
    line-height: 23px;
    color: #666666;
  `,
  ResultButton: styled(Button)`
    margin-top: 40px;
    width: 112px;
    height: 44px;
    font-size: 18px;
    line-height: 26px;
    color: #FFFFFF;
    background: #EF8200;
    border-radius: 4px;
  `,
};
export { S as default };
